module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M10.1 16.8l-4.4-4.5 1.4-1.4 3 3.1 6.8-6.8 1.4 1.4z\"></path></svg>"